export default "__VITE_ASSET__DnY_Z$LJ__"